import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const ImageContainer = styled.div`
  display: block;

  img {
    width: 100%;
  }
`

// TODO: refactor all of it!
// 1. don't use publicURL anymore ==> only gatsby image data
// 2. use new normalized model for blogPost
const getImageFromData = (image, title) => {
  if (!image) {
    return null
  }
  return image?.gatsbyImageData ? (
    <GatsbyImage
      image={getImage(image?.gatsbyImageData)}
      alt={image?.altText || title}
    />
  ) : (
    <img
      src={image && image.publicURL ? image.publicURL : image}
      alt={image?.altText || title}
    />
  )
}

const PostHero = ({ image, title, className }) =>
  image ? (
    <ImageContainer className={className}>
      {getImageFromData(image, title)}
    </ImageContainer>
  ) : null

PostHero.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.shape({
    publicURL: PropTypes.string,
  }),
}

export default PostHero
